const literales_en = {
  Dashboard: "Dashboard",
  Acciones: "Acciones comerciales",
  CasosUso: "Casos de uso",
  Exito:"Éxito",
  Ficheros: "Ficheros",
  Ajustes: "Ajustes",
  Notificaciones: "Notificaciones",
  Perfil: "Perfil",
  Usuarios: "Usuarios",
  CerrarSesion: "Cerrar sesión",
  LtFiltros: "Filtros",
  Aceptar: "Aceptar",
  TiposAccion:"Tipos acción",
};

export default literales_en;
